import { SET_BROADCAST_FEATURE_FLAGS } from 'actions/Types';

export default (state = {}, action) => {
  if (action.type === SET_BROADCAST_FEATURE_FLAGS) {
    return { ...action.payload };
  }

  return state;
};
